import {IForm} from '@/components/types'
import {useSearchDateShortcut} from "@/hooks/useSearch";

const shortcuts = useSearchDateShortcut()
export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelName',
      type: 'select',
      label: '渠道',
      clearable: true,
      filterable: true,
      placeholder: '请选择渠道',
      options: [
        { title: '直播', value: '直播' },
        { title: '打新', value: '打新' },
        { title: '诊股', value: '诊股' }
      ]
    },
    {
      field: 'timeSlot',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
